import Button from "components/Button";
import { ChangeEvent, useCallback, useState } from "react";
import { ITenantConfig, changeTenantConfig } from "services/TenantServices";
import { fireToast } from "services/sweetAlertConfig";
import debouncer from "utils/debouncer";
import { CurrentColor, CustomColorContainer } from "../../styles";

export default function SettingsTab() {
  const [selectedColor, setSelectedColor] = useState<string>("");

  const saveColor = useCallback(async () => {
    const userConfig = JSON.parse(localStorage.getItem("user") ?? "");

    if (userConfig) {
      const currentConfig = userConfig.tenant.config as ITenantConfig;
      const newConfig: ITenantConfig = {
        ...currentConfig,
        color: selectedColor,
      };
      try {
        await changeTenantConfig(newConfig);
      } catch {
        fireToast("Ocorreu um erro durante a troca das cores");
      } finally {
        window.location.reload();
      }
    }
  }, [selectedColor]);

  function handleColorInputChange(event: ChangeEvent<HTMLInputElement>) {
    setSelectedColor(event.target.value);
  }

  const debouncedHandleColorInputChange = debouncer(
    handleColorInputChange,
    500
  );

  return (
    <CustomColorContainer>
      <h2>Customizar cores</h2>
      <CurrentColor>
        Cor atual: <div />
      </CurrentColor>
      <label htmlFor="color-picker">
        Selecionar cor da plataforma
        <input
          autoComplete="off"
          type="color"
          defaultValue="var(--primary)"
          id="color-picker"
          onChange={(e: ChangeEvent<HTMLInputElement>) =>
            debouncedHandleColorInputChange(e)
          }
        />
        <Button title="Salvar alterações" onClick={saveColor} />
      </label>
    </CustomColorContainer>
  );
}
